import fetch from '@/utils/fetch';

//书本类型
export function findDicsByCode() {
    let params = new URLSearchParams();
    params.append("dicCode", 'equipType');
    return fetch({
        url: 'structure/sysDictionary/findDicsByCode',
        method: 'post',
        params: params
    });
}

//根据状态查询设备列表
export function getAllScancodeEquipmentListByState(query) {
    let params = new URLSearchParams();
    params.append('pageNo', query.pageNo);
    params.append('pageSize', query.pageSize);
    params.append('equipType', query.equipType);
    params.append('scanEquipId', query.scanEquipId);
    params.append('status', query.status);
    params.append('useType', query.useType);
    return fetch({
        url: 'structure/scancodeEquipment/getAllScancodeEquipmentListByState',
        method: 'get',
        params
    });
}


export function subFindDicsByCode(arg) {
    let params = new URLSearchParams();
    params.append("dicCode", arg.dicCode);
    return fetch({
        url: 'structure/sysDictionary/findDicsByCode',
        method: 'POST',
        params,
    });
}

// 统一处理请求参数
function filterURLSearchParams(args = {}) {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key]);
    })
    return params;
}

// 新增设备
export const addScancodeEquipment = data =>
    fetch({
        url: 'structure/scancodeEquipment/addScancodeEquipment',
        headers: {
            'content-type': 'application/json'
        },
        method: 'POST',
        data: JSON.stringify(data)
    })

// 查询周次列表
export const getSeveralWeekList = () =>
    fetch({
        url: 'structure/schoolTime/getSeveralWeekList',
        method: 'GET'
    })

// 根据id查扫码设备
export const getScancodeEquipmentById = params =>
    fetch({
        url: 'structure/scancodeEquipment/getScancodeEquipmentById',
        method: 'GET',
        params: filterURLSearchParams(params),
    })

// 批量删除设备
export const batchDeleteScancodeEquipment = params =>
    fetch({
        url: 'structure/scancodeEquipment/batchDeleteScancodeEquipment',
        method: 'GET',
        params: filterURLSearchParams(params),
    })

// 导出设备二维码
export const exportAllScancodeEquipmentList = params =>
    fetch({
        url: 'structure/scancodeEquipment/exportAllScancodeEquipmentList',
        method: 'GET',
        params: filterURLSearchParams(params),
    })
export const exportEquipmentLibraryList = params =>
    fetch({
        url: 'structure/scancodeEquipment/exportEquipmentLibraryList',
        method: 'GET',
        params: filterURLSearchParams(params),
    })
export const getEquipmentLibraryPage = params =>
    fetch({
        url: 'structure/scancodeEquipment/getEquipmentLibraryPage',
        method: 'GET',
        params: filterURLSearchParams(params),
    })

export const addEquipmentLibrary = data => {
    return fetch({
        url: 'structure/scancodeEquipment/addEquipmentLibrary',
        headers: {
            'content-type': 'application/json'
        },
        method: 'POST',
        data: JSON.stringify(data)
    })
}

export const delEquipmentLibrary = params =>
    fetch({
        url: 'structure/scancodeEquipment/delEquipmentLibrary',
        method: 'GET',
        params: filterURLSearchParams(params),
    })
export const getEquipmentLibrarySchoolStaticList = params =>
    fetch({
        url: 'structure/scancodeEquipment/getEquipmentLibrarySchoolStaticList',
        method: 'GET',
        params: filterURLSearchParams(params),
    })



// WEBPACK FOOTER //
// ./src/api/equipmentLibrary.js